export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* 顶部留给固定导航的空间 + 底部的暖色光晕 */}
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-accent-100/70 blur-3xl" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-40">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14">
          {/* 左栏：文案主导 */}
          <div className="w-full">
            <div className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
              <span className="text-xs font-medium text-foreground-700">今日已收录 108 个热点专楼与话题大全</span>
            </div>

            <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
              热门讨论太多？
              <br />
              让 <span className="relative inline-block text-primary-600">cg51</span> 帮你{" "}
              <span className="relative inline-block">
                分类分栋
                <span className="absolute -bottom-1 left-0 h-1 w-full rounded-full bg-accent-400" />
              </span>
              看。
            </h1>

            <p className="mt-6 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              进入 cg51 栏目导航，热点专楼、吃瓜合集、分区盘点与话题大全按兴趣收拢到一页。
              不用在多平台间来回翻找，顺着分区直达你关心的讨论，热门内容一页掌握。
            </p>

            {/* 行动按钮 */}
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                查看热点专楼
                <i className="ri-arrow-right-up-line text-base" />
              </a>
              <a
                href="#zones"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-grid-fill text-base" />
                浏览分区盘点
              </a>
            </div>

            {/* 高频直达标签 */}
            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="text-xs font-medium text-foreground-600">快捷直达：</span>
              <a href="#hot" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200">
                <i className="ri-fire-line text-xs" /> 热点专楼
              </a>
              <a href="#gossip" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 transition-colors hover:bg-accent-200">
                <i className="ri-bookmark-3-line text-xs" /> 吃瓜合集
              </a>
              <a href="#topics" className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-800 transition-colors hover:bg-primary-200">
                <i className="ri-bar-chart-2-line text-xs" /> 话题大全
              </a>
            </div>
          </div>

          {/* 右栏：配图对开 */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20editorial%20magazine%20collage%20wall%20of%20hot%20topic%20newsprint%20cards%20and%20gossip%20clippings%2C%20warm%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20gold%20headline%20typography%20accents%2C%20polaroid%20stickers%20and%20tape%2C%20artistic%20abstract%20flat%20lay%2C%20grainy%20texture%2C%20editorial%20layout%20not%20photorealistic&width=760&height=880&seq=hero-mag-2026&orientation=portrait"
                alt="cg51 热点专楼吃瓜合集专题合集展示图"
                title="cg51 话题大全 专题合集"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent" />
              {/* 数字角标 */}
              <div className="absolute right-3 top-3 flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-black text-foreground-950">
                51
              </div>
              {/* 底部图注 */}
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-fire-fill text-xs text-primary-600" /> 今日热门 · 分区盘点持续上新
                </span>
              </div>
            </div>

            {/* 浮动小卡片 */}
            <div className="cg-float absolute -left-4 top-10 hidden rounded-lg border border-background-200 bg-background-50/95 px-4 py-3 shadow-none sm:block md:-left-8">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-focus-3-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">正在被热议</p>
                  <p className="text-xs text-foreground-600">1,240 条实时讨论</p>
                </div>
              </div>
            </div>
            <div className="cg-float absolute -right-3 bottom-24 hidden rounded-lg border border-background-200 bg-background-50/95 px-4 py-3 sm:block md:-right-6" style={{ animationDelay: "1.2s" }}>
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className="ri-stack-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">32 个专区合集</p>
                  <p className="text-xs text-foreground-600">今晚前持续收集中</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 底部数据条 */}
        <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-4">
          {[
            { v: "12,800+", l: "收录热点专楼" },
            { v: "8", l: "常驻内容分区" },
            { v: "460+", l: "吃瓜合集存档" },
            { v: "分钟级", l: "话题热度刷新" },
          ].map((s) => (
            <div key={s.l} className="flex flex-col items-center gap-1 bg-background-50 px-4 py-5 text-center">
              <span className="font-heading text-xl font-black text-primary-700 md:text-2xl">{s.v}</span>
              <span className="text-xs text-foreground-600 md:text-sm">{s.l}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}